"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlotAfterHedgeFundCompianceExpiration = exports.doesSlotOverlapWithAnySchedules = exports.isSlotRequestedForSchedule = exports.splitInto15MinAvailabilities = exports.generateSlotsByDuration = exports.groupAdjacentAvailabilities = exports.generateSlots = exports.groupAvailabilities = void 0;
var tslib_1 = require("tslib");
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var time_1 = require("./time");
function groupAvailabilities(sortedAvailabilities) {
    var mergedAvailabilities = mergeAvailabilities(sortedAvailabilities);
    var availabilityGroups = mergedAvailabilities.reduce(function (groupedSlots, slot, index) {
        var newGroupId = slot.startTime;
        if (index === 0) {
            groupedSlots[newGroupId] = [slot];
            return groupedSlots;
        }
        var previousSlot = mergedAvailabilities[index - 1];
        if (shouldGroupSlot(previousSlot, slot)) {
            var lastGroupId = (0, last_1.default)(Object.keys(groupedSlots));
            groupedSlots[lastGroupId].push(slot);
        }
        else if (isIdenticalSlot(previousSlot, slot)) {
            /* just skip it */
        }
        else {
            groupedSlots[newGroupId] = [slot];
        }
        return groupedSlots;
    }, {});
    return availabilityGroups;
}
exports.groupAvailabilities = groupAvailabilities;
function shouldGroupSlot(previousSlot, currentSlot) {
    if (currentSlot.type !== previousSlot.type)
        return false;
    if ((0, time_1.isSameTime)(currentSlot.startTime, previousSlot.endTime))
        return true;
    // slots are sorted by start time, no need don't check it here,
    // we just have to make sure start time is earlier than end time of our previous slot
    if (currentSlot.startTime < previousSlot.endTime)
        return true;
    return false;
}
function isIdenticalSlot(previousSlot, currentSlot) {
    return previousSlot.type === currentSlot.type && (0, time_1.isSameTime)(previousSlot.startTime, currentSlot.startTime);
}
function mergeAvailabilities(sortedAvailabilities) {
    return sortedAvailabilities.reduce(function (availabilities, availability, index) {
        if (index === 0) {
            availabilities.push(availability);
            return availabilities;
        }
        var previousAvailability = (0, last_1.default)(availabilities);
        if (isIdenticalSlot(previousAvailability, availability)) {
            /* Do nothing, we already have the slot we need */
        }
        else if (shouldBeMerged(previousAvailability, availability)) {
            mergeEntries(previousAvailability, availability);
        }
        else if (doesCurrentFitIntoPreviousAvailability(previousAvailability, availability)) {
            // just skip
        }
        else if (doesPreviousFitIntoCurrentAvailability(previousAvailability, availability)) {
            // just skip
        }
        else {
            availabilities.push(availability);
        }
        return availabilities;
    }, []);
}
function shouldBeMerged(previousAvailability, currentAvailability) {
    // allow the merged if one is already merged (the "BOTH" type)
    var allowAlreadyMerged = (previousAvailability.type === 'BOTH' || currentAvailability.type === 'BOTH') &&
        (0, time_1.isSameTime)(previousAvailability.startTime, currentAvailability.startTime);
    if (allowAlreadyMerged)
        return true;
    var areDifferentTypesAndAtTheSameTime = previousAvailability.type !== currentAvailability.type &&
        (0, time_1.isSameTime)(previousAvailability.startTime, currentAvailability.startTime);
    if (areDifferentTypesAndAtTheSameTime)
        return true;
    return false;
}
// eslint-disable-next-line no-unused-vars
function isOverlapping(previousAvailability, currentAvailability) {
    if (doesPreviousFitIntoCurrentAvailability(previousAvailability, currentAvailability)) {
        return true;
    }
    if (doesCurrentFitIntoPreviousAvailability(previousAvailability, currentAvailability)) {
        return true;
    }
    return false;
}
function doesPreviousFitIntoCurrentAvailability(previousAvailability, currentAvailability) {
    return ((0, moment_1.default)(previousAvailability.startTime).isSameOrAfter(currentAvailability.startTime) &&
        (0, moment_1.default)(previousAvailability.endTime).isSameOrBefore(currentAvailability.endTime));
}
function doesCurrentFitIntoPreviousAvailability(previousAvailability, currentAvailability) {
    return ((0, moment_1.default)(currentAvailability.startTime).isSameOrAfter(previousAvailability.startTime) &&
        (0, moment_1.default)(currentAvailability.endTime).isSameOrBefore(previousAvailability.endTime));
}
function mergeEntries(previousAvailability, currentAvailability) {
    previousAvailability.type = 'BOTH';
    if (currentAvailability.expertAvailabilityId && currentAvailability.clientAvailabilityId) {
        // if this warning triggers there are probably multiple slots of the same type
        // either clientToProjectAvailability
        // or expertAvailabilityToEpl
        // which have the same start/end time
        console.error("\n        WARNING: There are duplicated availabilities, slots with same start/end time.\n\n        Merging slot(clientAvailability: ".concat(previousAvailability.clientAvailabilityId, ", expertAvailability: ").concat(previousAvailability.expertAvailabilityId, ")\n            and slot(clientAvailability: ").concat(currentAvailability.clientAvailabilityId, ", expertAvailability: ").concat(currentAvailability.expertAvailabilityId, ")\n        "));
    }
    if (currentAvailability.expertAvailabilityId) {
        previousAvailability.expertAvailabilityId = currentAvailability.expertAvailabilityId;
    }
    if (currentAvailability.clientAvailabilityId) {
        previousAvailability.clientAvailabilityId = currentAvailability.clientAvailabilityId;
    }
}
function generateSlots(duration, availabilities, scheduleRequests, schedule, otherSchedules) {
    if (scheduleRequests === void 0) { scheduleRequests = []; }
    if (schedule === void 0) { schedule = null; }
    if (otherSchedules === void 0) { otherSchedules = []; }
    var groupedAvailabilities = groupAdjacentAvailabilities(availabilities);
    var groupedSlots = groupedAvailabilities.map(function (availabilityGroup) {
        return generateSlotsByDuration(duration, availabilityGroup, scheduleRequests, schedule, otherSchedules);
    });
    return (0, flatten_1.default)(groupedSlots);
}
exports.generateSlots = generateSlots;
function groupAdjacentAvailabilities(availabilities) {
    var slots = availabilities.reduce(function (mergedSlots, av) {
        var lastSlot = (0, last_1.default)(mergedSlots);
        if (!lastSlot) {
            mergedSlots.push({
                startTime: av.startTime,
                endTime: av.endTime,
                availabilities: [av],
            });
            return mergedSlots;
        }
        if ((0, time_1.isSameTime)(lastSlot.endTime, av.startTime)) {
            lastSlot.endTime = av.endTime;
            lastSlot.availabilities.push(av);
            return mergedSlots;
        }
        mergedSlots.push({
            startTime: av.startTime,
            endTime: av.endTime,
            availabilities: [av],
        });
        return mergedSlots;
    }, []);
    return slots.map(function (s) { return s.availabilities; });
}
exports.groupAdjacentAvailabilities = groupAdjacentAvailabilities;
/**
 * Function will generate slots based on the passed duration and availabilities.
 *
 * If the availability is:
 * - equal to the passed duration - it will represent one slot
 * - if it's shorter - multiple availabilities will be unified to represent one slot
 * - if it's longer - it will be broken up in pieces and then represent one or multiple slots
 *
 * @param {Number} duration
 * @param {Array} availabilities
 */
function generateSlotsByDuration(duration, availabilities, scheduleRequests, schedule, otherSchedules) {
    if (scheduleRequests === void 0) { scheduleRequests = []; }
    if (schedule === void 0) { schedule = null; }
    var startTime = (0, first_1.default)(availabilities).startTime;
    var endTime = (0, last_1.default)(availabilities).endTime;
    var slotSpan = new Date(endTime).getTime() - new Date(startTime).getTime();
    var durationInMs = duration * 60 * 1000;
    if (slotSpan < durationInMs)
        return [];
    var slots = availabilities.reduce(function (ar, av, index) {
        var isAvailabilityDurationEqualToOneSlot = getDuration(av) === durationInMs;
        if (isAvailabilityDurationEqualToOneSlot) {
            ar.push({
                startTime: av.startTime,
                endTime: av.endTime,
                availabilities: [av],
            });
            return ar;
        }
        var isAvailabilityDurationShorterThanOneSlot = getDuration(av) < durationInMs;
        if (isAvailabilityDurationShorterThanOneSlot) {
            var avs = [av];
            while (getDiff((0, first_1.default)(avs), (0, last_1.default)(avs)) < durationInMs) {
                var nextAvailability = availabilities[index + avs.length];
                if (!nextAvailability)
                    return ar;
                avs.push(nextAvailability);
            }
            ar.push({
                startTime: (0, first_1.default)(avs).startTime,
                endTime: (0, last_1.default)(avs).endTime,
                availabilities: avs,
            });
            return ar;
        }
        var isAvailabilityLongerThanOneSlot = getDuration(av) > durationInMs;
        if (isAvailabilityLongerThanOneSlot) {
            var slotCount = getDuration(av) / durationInMs;
            for (var i = 0; i < slotCount; i++) {
                ar.push({
                    startTime: new Date(av.startTime).getTime() + durationInMs * i,
                    endTime: new Date(av.startTime).getTime() + durationInMs * (i + 1),
                    availabilities: [av],
                });
            }
            return ar;
        }
        return ar;
    }, []);
    var markedSlots = markSchedulesAndScheduleRequestsOnSlots(slots, scheduleRequests, schedule, otherSchedules);
    return filterOutPastNonMarkedSlots(markedSlots);
}
exports.generateSlotsByDuration = generateSlotsByDuration;
/**
 * Filters out slots which have passed and which aren't related
 * to schedules nor schedule requests.
 *
 * @param {array} slots
 * @returns {array} slots slots happening in the future or are marked scheduled/schedule request
 */
function filterOutPastNonMarkedSlots(slots) {
    return slots.filter(function (slot) {
        if (slot.schedule || slot.requestSchedule)
            return true;
        var hasPassed = (0, moment_1.default)(slot.endTime).isSameOrBefore(new Date());
        if (!hasPassed)
            return true;
        return false;
    });
}
function markSchedulesAndScheduleRequestsOnSlots(slots, scheduleRequests, schedule, otherSchedules) {
    if (scheduleRequests === void 0) { scheduleRequests = []; }
    if (schedule === void 0) { schedule = null; }
    if (otherSchedules === void 0) { otherSchedules = []; }
    if (scheduleRequests.length === 0 && !schedule && otherSchedules.length === 0) {
        return slots;
    }
    slots.forEach(function (slot) {
        var matchingRequestSchedule = scheduleRequests.find(function (request) {
            return (0, time_1.isSameTime)(request.startTime, slot.startTime) && (0, time_1.isSameTime)(request.endTime, slot.endTime);
        });
        if (doesSlotOverlapWithAnySchedules(otherSchedules, slot)) {
            slot.taken = true;
        }
        if (matchingRequestSchedule) {
            slot.requestSchedule = matchingRequestSchedule;
        }
        if (!schedule)
            return;
        if ((0, time_1.isSameTime)(slot.startTime, schedule.startTime) && (0, time_1.isSameTime)(slot.endTime, schedule.endTime)) {
            slot.schedule = schedule;
        }
    });
    return slots;
}
function getDiff(formerAvailability, laterAvailability) {
    var diff = new Date(laterAvailability.endTime).getTime() - new Date(formerAvailability.startTime).getTime();
    return diff;
}
function getDuration(availability) {
    return getDiff(availability, availability);
}
function splitInto15MinAvailabilities(availability) {
    var interval = 15;
    var differenceInMinutes = (0, moment_1.default)(availability.endTime).diff(availability.startTime, 'minutes');
    var fifteenMinSlotCount = differenceInMinutes / interval;
    var availabilities = [];
    for (var i = 0; i < fifteenMinSlotCount; i++) {
        var startTime = (0, moment_1.default)(availability.startTime).add(interval * i, 'minutes');
        var endTime = (0, moment_1.default)(availability.startTime).add(interval * (i + 1), 'minutes');
        availabilities.push(tslib_1.__assign(tslib_1.__assign({}, availability), { startTime: startTime.toDate().toISOString(), endTime: endTime.toDate().toISOString() }));
    }
    return availabilities;
}
exports.splitInto15MinAvailabilities = splitInto15MinAvailabilities;
function isSlotRequestedForSchedule(scheduleRequests, slot) {
    if (scheduleRequests === void 0) { scheduleRequests = []; }
    if (scheduleRequests.length === 0)
        return false;
    var matchingScheduleRequest = scheduleRequests.find(function (request) {
        return "".concat(request.startTime, "-").concat(request.endTime) === "".concat(slot.startTime, "-").concat(slot.endTime);
    });
    return !!matchingScheduleRequest;
}
exports.isSlotRequestedForSchedule = isSlotRequestedForSchedule;
function doesSlotOverlapWithAnySchedules(schedules, slot) {
    if (schedules.length === 0)
        return false;
    if (slot.scheduleId)
        return true;
    var overlap = schedules.find(function (schedule) {
        if ((0, moment_1.default)(schedule.startTime).isBetween(slot.startTime, slot.endTime)) {
            return true;
        }
        if ((0, moment_1.default)(schedule.endTime).isBetween(slot.startTime, slot.endTime)) {
            return true;
        }
        if ((0, moment_1.default)(schedule.startTime).isSameOrBefore(slot.startTime) &&
            (0, moment_1.default)(schedule.endTime).isSameOrAfter(slot.endTime)) {
            return true;
        }
        return false;
    });
    return !!overlap;
}
exports.doesSlotOverlapWithAnySchedules = doesSlotOverlapWithAnySchedules;
function isSlotAfterHedgeFundCompianceExpiration(slot, epl, staticData) {
    var latestValidHfCompliance = epl.expert.hfCompliances.find(function (hfc) { return hfc.isConfirmed; });
    if (!latestValidHfCompliance)
        return true;
    return (0, moment_1.default)(slot.endTime).isAfter((0, moment_1.default)(latestValidHfCompliance.createdAt).add('days', staticData.hfComplianceExpiryDays));
}
exports.isSlotAfterHedgeFundCompianceExpiration = isSlotAfterHedgeFundCompianceExpiration;
